module.exports = "<div class=\"exclusions-component\">\n  <reusable-card icon=\"trending_up\" title=\"Fee Exclusions\" loading=\"$ctrl.isLoading\">\n    <card-content>\n      <reusable-table\n        columns=\"$ctrl.exclusionColumns\"\n        data=\"$ctrl.allExclusions\"\n        hide-delete-button=\"true\"\n        readonly=\"!$ctrl.canEdit\"\n        on-refresh=\"$ctrl.getClientFeeExclusions()\"\n        on-add=\"$ctrl.addFeeExclusion()\"\n        on-edit=\"$ctrl.editFeeExclusion(item)\">\n      </reusable-table>\n    </card-content>\n  </reusable-card>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/fees/exclusions/exclusions.html
// module id = 1223
// module chunks = 0